// App.tsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

// Layouts
import SiteLayout from "@/components/layout/SiteLayout";
import AdminLayout from "@/components/admin/AdminLayout";
 
// Pages
import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/auth/AdminLogin";
import AdminResetPassword from "@/pages/auth/AdminResetPassword";
import UserVerification from "@/pages/auth/UserVerification";
import SubscriptionPage from "@/pages/account/SubscriptionPage";
import ProfilePage from "@/pages/account/ProfilePage";
import SettingsDashboard from "@/pages/admin/SettingsDashboard";
import SimpleQuoteManager from "@/pages/admin/SimpleQuoteManager";
import CategoryManager from "@/pages/admin/CategoryManager";
import SubscriberManager from "@/pages/admin/SubscriberManager";
import MessageLogs from "@/pages/admin/MessageLogs";
import SystemSettings from "@/pages/admin/SystemSettings";
import ImportQuotes from "@/pages/admin/ImportQuotes";
import ConfirmProfileLink from "@/pages/admin/ConfirmProfileLink";

const App = () => {
  return (
    <ErrorBoundary>
      <TooltipProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster />
            <Sonner />
            <Routes>
              {/* Public Routes */}
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Index />} />
                <Route path="/verify" element={<UserVerification />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              {/* Auth Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="/admin/confirm-link" element={<ConfirmProfileLink />} />

              {/* Protected User Routes */}
              <Route element={<SiteLayout />}>
                <Route
                  path="/account/subscription"
                  element={
                    <ProtectedRoute>
                      <SubscriptionPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/account/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Protected Admin Routes */}
              <Route
                path="/settings"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<SettingsDashboard />} />
                <Route path="quotes" element={<SimpleQuoteManager />} />
                <Route path="import-quotes" element={<ImportQuotes />} />
                <Route path="categories" element={<CategoryManager />} />
                <Route path="subscribers" element={<SubscriberManager />} />
                <Route path="logs" element={<MessageLogs />} />
                <Route path="system" element={<SystemSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </ErrorBoundary>
  );
};

export default App;
 